import {
  URL_REGEX,
  parseJsonSafe,
  isValidPort,
  validationResult,
} from "./patterns";

const FIELD_RULES = {
  url: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "URL is required");
      if (!URL_REGEX.test(s)) {
        return validationResult(false, "Enter a valid URL starting with http:// or https://");
      }
      return validationResult(true);
    },
  },
  token: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Token is required");
      return validationResult(true);
    },
  },
  index: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Index is required");
      return validationResult(true);
    },
  },
  headers: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(true);
      const parsed = parseJsonSafe(s);
      if (!parsed.ok) return validationResult(false, `Headers: invalid JSON (${parsed.message})`);
      return validationResult(true);
    },
  },
  region: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Region is required");
      return validationResult(true);
    },
  },
  accessKey: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Access key is required");
      return validationResult(true);
    },
  },
  secretKey: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Secret key is required");
      return validationResult(true);
    },
  },
  logGroup: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Log group is required");
      return validationResult(true);
    },
  },
  projectId: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Project ID is required");
      return validationResult(true);
    },
  },
  credentials: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Credentials are required");
      const parsed = parseJsonSafe(s);
      if (!parsed.ok) return validationResult(false, `Credentials: invalid JSON (${parsed.message})`);
      return validationResult(true);
    },
  },
  apiKey: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "API key is required");
      return validationResult(true);
    },
  },
  host: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Host is required");
      return validationResult(true);
    },
  },
  port: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Port is required");
      if (!isValidPort(s)) return validationResult(false, "Port must be between 1 and 65535");
      return validationResult(true);
    },
  },
  protocol: {
    validate: (v) => {
      const s = String(v ?? "").trim().toLowerCase();
      if (!s) return validationResult(false, "Protocol is required");
      if (!["tcp", "udp"].includes(s)) return validationResult(false, "Protocol must be tcp or udp");
      return validationResult(true);
    },
  },
  site: {
    validate: (v) => {
      const s = String(v ?? "").trim();
      if (!s) return validationResult(false, "Site is required");
      return validationResult(true);
    },
  },
};

export function validateWebhookField(fieldKey, value) {
  const rule = FIELD_RULES[fieldKey];
  if (!rule) return validationResult(true);
  return rule.validate(value);
}

export function validateWebhookForm(webhookFields, formValues) {
  const fieldErrors = {};
  for (const key of webhookFields || []) {
    const result = validateWebhookField(key, formValues?.[key]);
    if (!result.valid) fieldErrors[key] = result.message;
  }
  const valid = Object.keys(fieldErrors).length === 0;
  return { valid, fieldErrors };
}
